import React from 'react'
import propTypes from 'prop-types'
import {isNil} from 'lodash'
import FinancialString from 'containers/financialString'
import {getPercentageString, getTotalProfit} from "helpers/financial"

const QuotesTotal = (props) => {
  const {totalPrice, totalCost, totalMargin} = props

  const styles = {
    total: {
      paddingLeft: 12,
      fontWeight: 'bold',
      fontSize: 13,
      whiteSpace: 'nowrap',
    },
    totalView: {
      display: 'flex',
      background1Color: 'red',
      flexDirection: 'row',
    },
  }

  const totalProfit = getTotalProfit(totalPrice, totalCost)

  return (
    <div style={styles.totalView}>
      {!isNil(totalCost) && (
        <div style={styles.total}>
          Total Cost: <FinancialString inline value={totalCost}/>
        </div>
      )}
      {!isNil(totalPrice) && (
        <div style={styles.total}>
          Total Price: <FinancialString inline value={totalPrice}/>
        </div>
      )}
      {!isNil(totalMargin) && (
        <div style={styles.total}>
          Margin: {getPercentageString(totalMargin, 2)}
        </div>
      )}
      {!isNil(totalProfit) && (
        <div style={styles.total}>
          Profit: <FinancialString inline value={totalProfit}/>
        </div>
      )}
    </div>
  )
}

QuotesTotal.propTypes = {
  totalCost: propTypes.number,
  totalMargin: propTypes.number,
  totalPrice: propTypes.number,
}

export default QuotesTotal
